import React, { useState, useEffect, useContext } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  MenuItem,
  Button,
  Autocomplete,
  Fade,
  Backdrop
} from "@mui/material";
import { useTranslation } from "react-i18next";
import ImgStepTwo from "../../../../../assets/Images/CarePlan2.jpg";
import { CarePlanContext } from "../../../../../context/CarePlanContext/CarePlanContext";

// Importar JSON de diagnósticos
import diagnosesDataJson from '../../../../../utils/Apis/ApisJson/diagnoses.json';

export default function DiagnosisModal({ open, onClose, onSave }) {
  const { t } = useTranslation();

  const { fetchDiagnosesWithStandard } = useContext(CarePlanContext);
  const [diagnosesWithStandard, setDiagnosesWithStandard] = useState([]);

  // Estado para el formulario
  const [diagnosisType, setDiagnosisType] = useState("all");
  const [selectedDiagnosis, setSelectedDiagnosis] = useState(null);
  const [selectedDiagnosisCode, setSelectedDiagnosisCode] = useState("");

  // Lista de tipos de diagnóstico
  const diagnosisTypes = [
    { value: "all", label: t("CarePlan.diagnosis.types.all") },
    { value: "With standard", label: t("CarePlan.diagnosis.types.common") }
  ];

  useEffect(() => {
    if (diagnosisType === "With standard") {
      fetchDiagnosesWithStandard().then(setDiagnosesWithStandard);
    }
  }, [diagnosisType]);

  const allDiagnosisOptions = diagnosesDataJson.map((diag) => ({
    code: diag.code,
    label: `${diag.code} - ${diag.description}`,
    standardCarePlanId: null
  }));

  const standardDiagnosisOptions = diagnosesWithStandard.map((diag) => ({
    code: diag.diagnosisName.split("-")[0],
    label: diag.diagnosisName,
    standardCarePlanId: diag.standardCarePlanId
  }));

  const diagnosisOptions =
    diagnosisType === "With standard"
      ? standardDiagnosisOptions
      : allDiagnosisOptions;

      const handleSave = () => {
        if (!selectedDiagnosis) return;

        const newDiagnosis = {
          id: Date.now(),
          date: new Date().toLocaleDateString(),
          name: selectedDiagnosis.label,
          code: selectedDiagnosis.code,
          type:
            diagnosisType === "With standard"
              ? t("CarePlan.diagnosis.types.common")
              : t("CarePlan.diagnosis.types.all"),
          status: "Activo",
          standardCarePlanId: selectedDiagnosis.standardCarePlanId || null
        };

        // HIPAA: se eliminó la escritura de selectedDiagnosisCode en localStorage
        // (código ICD-10 = PHI clínico; además nunca se leía — escritura muerta)
        onSave(newDiagnosis);
        onClose();
      };

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <Box
          sx={{
            width: "500px",
            backgroundColor: "#fff",
            borderRadius: "10px",
            p: 3,
            boxShadow: 3,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center"
          }}
        >
          {/* Título */}
          <Typography variant="h5" sx={{ fontWeight: "bold", color: "#085394", mb: 2 }}>
            {t("CarePlan.diagnosis.newDiagnosis")}
          </Typography>

          {/* Selector de tipo de diagnóstico */}
          <TextField
            select
            fullWidth
            label={t("CarePlan.diagnosis.type")}
            value={diagnosisType}
            onChange={(e) => setDiagnosisType(e.target.value)}
            sx={{ mb: 2 }}
          >
            {diagnosisTypes.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

          {/* Autocompletar de diagnóstico */}
          <Autocomplete
            options={diagnosisOptions}
            getOptionLabel={(option) => option.label}
            value={selectedDiagnosis}
            onChange={(event, newValue) => {
              setSelectedDiagnosis(newValue);
              setSelectedDiagnosisCode(newValue ? newValue.code : "");
            }}
            renderInput={(params) => <TextField {...params} label={t("CarePlan.diagnosis.search")} />}
            sx={{ mb: 3 }}
          />

          {/* Imagen de fondo difuminada */}
          <Box
            sx={{
              backgroundImage: `url(${ImgStepTwo})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              opacity: 0.2,
              height: "120px",
              borderRadius: "8px",
              mb: 2
            }}
          />

          {/* Botón de Guardar */}
          <Button
            variant="contained"
            color="success"
            fullWidth
            onClick={handleSave}
          >
            {t("common.save")}
          </Button>
        </Box>
      </Fade>
    </Modal>
  );
}
